import { Card, CardContent } from '../../../components/ui/card';

export const OverviewCards = ({
  activeTab,
  onTabChange,
  prescreenCount,
  dpiaCount,
  liaCount,
  tiaCount
}) => {
  const cards = [
    {
      id: 'prescreen',
      label: 'Pre-screen assessments',
      count: prescreenCount,
      borderClass: 'border-l-amber-600 dark:border-l-amber-400',
      countClass: 'text-amber-600 dark:text-amber-400',
    },
    {
      id: 'dpia',
      label: 'DPIAs',
      count: dpiaCount,
      borderClass: 'border-l-red-600 dark:border-l-red-400',
      countClass: 'text-red-600 dark:text-red-400',
    },
    {
      id: 'lia',
      label: 'Legitimate interest assessments',
      count: liaCount,
      borderClass: 'border-l-blue-600 dark:border-l-blue-400',
      countClass: 'text-blue-600 dark:text-blue-400',
    },
    {
      id: 'tia',
      label: 'Transfer impact assessments',
      count: tiaCount,
      borderClass: 'border-l-slate-600 dark:border-l-slate-400',
      countClass: 'text-slate-600 dark:text-slate-400',
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((card) => {
        const borderColorMap = {
          'prescreen': '#FBBF24', // amber-400
          'dpia': '#F87171', // red-400
          'lia': '#60A5FA', // blue-400
          'tia': '#94A3B8', // slate-400
        };
        const borderColor = activeTab === card.id ? 'hsl(var(--primary))' : borderColorMap[card.id];

        return (
          <Card
            key={card.id}
            onClick={() => onTabChange(card.id)}
            style={{
              borderLeftWidth: '6px',
              borderLeftColor: borderColor,
            }}
            className={`cursor-pointer transition-all ${
              activeTab === card.id
                ? 'bg-primary/5 shadow-md'
                : 'hover:shadow-md'
            }`}
            data-testid={`overview-card-${card.id}`}
          >
          <CardContent className="p-6">
            <p className="text-sm text-muted-foreground mb-2">{card.label}</p>
            <p className={`text-3xl font-bold ${
              activeTab === card.id ? 'text-primary' : card.countClass
            }`}>
              {card.count}
            </p>
          </CardContent>
          </Card>
        );
      })}
    </div>
  );
};
